export default "__VITE_ASSET__S6iwyJrC__"